module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_settings')))]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "callSettings"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveSettings($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "call_tries"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_tries')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tries),
      expression: "tries"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "call_tries",
      "formControlName": "call_tries"
    },
    domProps: {
      "value": (_vm.tries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tries = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "call_all_contacts"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_v5_tries_period')))]), _vm._v(" "), _c('app-slider', {
    attrs: {
      "min": "1",
      "max": "9",
      "step": "1",
      "raising": "",
      "values": _vm.ticksVals
    },
    model: {
      value: (_vm.triesPeriod),
      callback: function($$v) {
        _vm.triesPeriod = $$v
      },
      expression: "triesPeriod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "call_all_contacts"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_v5_call_all_contacts')))]), _vm._v(" "), _c('app-switch', {
    attrs: {
      "id": "call_all_contacts",
      "autoSave": false,
      "isInList": false,
      "identification": "callAll"
    },
    model: {
      value: (_vm.callAll),
      callback: function($$v) {
        _vm.callAll = $$v
      },
      expression: "callAll"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveSettings($event)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('button_label_submit')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-079dec70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/settings/call_settings.vue
// module id = 663
// module chunks = 0